<template>
  <button
    :disabled="isDisabled"
    class="boss-button boss-button-confirm pega-button"
    :class="buttonClass"
    @click="$emit('submit-event')"
  >
    <span class="boss-button-confirm-text">
      {{ submitLabel }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: null
    },
    submitLabel: {
      type: String,
      required: true
    }
  }
}
</script>
